import { Card, CardContent, Grid, Typography } from "@mui/material";
import { DocumentosAgrupados } from "../DocumentosAgrupados/DocumentosAgrupados";
import { useOnlineStatus } from "../../hooks/useSync";

export const Documents = ({
  elementoActivo,
  user,
  plantaActiva,
  clienteSeleccionado,
  elementoGeneralSeleccionado,
}) => {
  const isOnline = useOnlineStatus();

  return (
    <>
      <Card style={{ height: "600px", overflowY: "auto" }}>
        <CardContent sx={{ p: 2 }}>
          <Grid item xs={12} sx={{ pb: 2 }}>
            <div style={{ display: "flex", flexDirection: "row" }}>
              <Typography variant="h6">Documentos</Typography>
            </div>
          </Grid>
          {elementoActivo.nombre ? (
            <Grid container spacing={2}>
              <Grid item xs={12}>
                <Grid item xs={12}>
                  <Card style={{ height: "600px", overflowY: "auto" }}>
                    <CardContent sx={{ p: 2 }}>
                      {isOnline ? (
                        <DocumentosAgrupados
                          idUsuario={user.idPerfil}
                          planta={plantaActiva}
                          cliente={clienteSeleccionado}
                          elementoActivo={elementoActivo.nombre}
                        />
                      ) : (
                        <Typography
                          variant="body2"
                          color="text.secondary"
                          sx={{ mt: 2 }}
                        >
                          Los documentos no están disponibles sin conexión.
                        </Typography>
                      )}
                    </CardContent>
                  </Card>
                </Grid>
              </Grid>
            </Grid>
          ) : (
            elementoGeneralSeleccionado !== undefined && (
              <Grid container spacing={2}>
                <Grid item xs={12}>
                  <h4 style={{ marginLeft: "10px", fontSize: "1.25rem" }}>
                    {elementoGeneralSeleccionado.descripcion !== null &&
                    elementoGeneralSeleccionado.descripcion?.trim() !== ""
                      ? elementoGeneralSeleccionado.nombre +
                        " " +
                        elementoGeneralSeleccionado.descripcion
                      : elementoGeneralSeleccionado.nombre +
                        " " +
                        elementoGeneralSeleccionado.numero}
                  </h4>
                </Grid>
                <Grid item xs={12}>
                  <Card style={{ height: "600px", overflowY: "auto" }}>
                    <CardContent sx={{ p: 2 }}>
                      {isOnline ? (
                        <DocumentosAgrupados
                          idUsuario={user.idPerfil}
                          planta={plantaActiva}
                          cliente={clienteSeleccionado}
                          elementoActivo={
                            elementoGeneralSeleccionado.descripcion !== null &&
                            elementoGeneralSeleccionado.descripcion?.trim() !==
                              ""
                              ? elementoGeneralSeleccionado.nombre +
                                " " +
                                elementoGeneralSeleccionado.descripcion
                              : elementoGeneralSeleccionado.nombre +
                                " " +
                                elementoGeneralSeleccionado.numero
                          }
                        />
                      ) : (
                        <Typography
                          variant="body2"
                          color="text.secondary"
                          sx={{ mt: 2 }}
                        >
                          Los documentos no están disponibles sin conexión.
                        </Typography>
                      )}
                    </CardContent>
                  </Card>
                </Grid>
              </Grid>
            )
          )}
        </CardContent>
      </Card>
    </>
  );
};
